export enum AudioNames {
    MainMusic = "main_music",
    Click = "ui_click",
    SelectFigure = "select_figure",
    PlaceFigure = "place_figure",
    DestroyFigures = "destroy_figures",
    Combo = "combo"
}